import config from "../../../config/config";
import { authFetch, buildAuthHeaders } from "../../../public/api/httpClient";

const API = `${config.BASE_URL}/cheque-issues`;


async function parseJson(res) {
  const text = await res.text();
  if (text.trim().startsWith("<")) {
    return { message: "Server Error: An unexpected error occurred on the server." };
  }
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return { message: text || "Invalid response" };
  }
}

async function handleRequest(url, options = {}, errorMsg) {
  const { headers: extraHeaders, ...restOptions } = options;
  const res = await authFetch(url, {
    credentials: "include",
    headers: buildAuthHeaders(extraHeaders || {}),
    ...restOptions,
  });

  const data = await parseJson(res);

  if (!res.ok) {
    throw new Error(data.message || errorMsg);
  }

  return data;
}

export const fetchChequeTypes = async () => {
  return handleRequest(`${API}/cheque-types`, {}, "Error fetching cheque types");
};

export const createChequeType = async (data, csrfToken) => {
  return handleRequest(
    `${API}/cheque-types`,
    {
      method: "POST",
      headers: csrfToken ? { "X-CSRF-Token": csrfToken } : {},
      body: JSON.stringify(data),
    },
    "Error creating cheque type",
  );
};

export const updateChequeType = async (id, data, csrfToken) => {
  return handleRequest(
    `${API}/cheque-types/${id}`,
    {
      method: "PUT",
      headers: csrfToken ? { "X-CSRF-Token": csrfToken } : {},
      body: JSON.stringify(data),
    },
    "Error updating cheque type",
  );
};

export const deleteChequeType = async (id, csrfToken) => {
  return handleRequest(
    `${API}/cheque-types/${id}`,
    {
      method: "DELETE",
      headers: csrfToken ? { "X-CSRF-Token": csrfToken } : {},
    },
    "Error removing cheque type",
  );
};

export const fetchBankStatusOptions = async () => {
  return handleRequest(`${API}/banks/status-options`, {}, "Error fetching bank statuses");
};

export const fetchBanks = async () => {
  return handleRequest(`${API}/banks`, {}, "Error fetching banks");
};

export const createBank = async (data, csrfToken) => {
  return handleRequest(
    `${API}/banks`,
    {
      method: "POST",
      headers: csrfToken ? { "X-CSRF-Token": csrfToken } : {},
      body: JSON.stringify(data),
    },
    "Error creating bank",
  );
};

export const updateBank = async (id, data, csrfToken) => {
  return handleRequest(
    `${API}/banks/${id}`,
    {
      method: "PUT",
      headers: csrfToken ? { "X-CSRF-Token": csrfToken } : {},
      body: JSON.stringify(data),
    },
    "Error updating bank",
  );
};

export const deleteBank = async (id, csrfToken) => {
  return handleRequest(
    `${API}/banks/${id}`,
    {
      method: "DELETE",
      headers: csrfToken ? { "X-CSRF-Token": csrfToken } : {},
    },
    "Error removing bank",
  );
};

export const fetchChequeStatuses = async () => {
  return handleRequest(`${API}/cheque-statuses`, {}, "Error fetching cheque statuses");
};

export const createChequeStatus = async (data, csrfToken) => {
  return handleRequest(
    `${API}/cheque-statuses`,
    {
      method: "POST",
      headers: csrfToken ? { "X-CSRF-Token": csrfToken } : {},
      body: JSON.stringify(data),
    },
    "Error creating cheque status",
  );
};

export const updateChequeStatus = async (id, data, csrfToken) => {
  return handleRequest(
    `${API}/cheque-statuses/${id}`,
    {
      method: "PUT",
      headers: csrfToken ? { "X-CSRF-Token": csrfToken } : {},
      body: JSON.stringify(data),
    },
    "Error updating cheque status",
  );
};

export const deleteChequeStatus = async (id, csrfToken) => {
  return handleRequest(
    `${API}/cheque-statuses/${id}`,
    {
      method: "DELETE",
      headers: csrfToken ? { "X-CSRF-Token": csrfToken } : {},
    },
    "Error removing cheque status",
  );
};
